// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--Byeh1","content":"style-module--content--2lnZU","clickableTint":"style-module--clickableTint--2-8i6"};